import moment from 'moment';
import axios from './axiosInstance';
import Config from '../config';

export default class API {

  static getParameters() {
    return axios.get(Config.API_URL.GET_PARAMETERS);
  }

  /**
   * Return all services, ordered by category
   */
  static getServices() {
    return axios.get(Config.API_URL.GET_SERVICES);
  }

  static getEmployees(services) {
    return axios.get(Config.API_URL.GET_EMPLOYEES+'/'+services);
  }

  static getAvailableDays(date, duration, services, employee = null) {
    // Ensure date has proper format
    if (moment.isMoment(date)) date = date.format('DD-MM-YYYY');

    // Ensure duration is a positive integer
    duration = parseInt(duration, 10);
    if (duration < 0) duration = 0;

    return axios.get(
      Config.API_URL.GET_AVAILABLE_DAYS + '/'
      + date
      + '/'
      + duration
      + '/'
      + services
      + '/employee/'
      + employee
    )
  }

  static getAvailableTimes(date, duration, services,  employee = null) {
    // Ensure date has proper format
    if (moment.isMoment(date)) date = date.format('DD-MM-YYYY');

    // Ensure duration is a positive integer
    if (duration < 0) duration = 0;

    return axios.get(`${Config.API_URL.GET_AVAILABLE_TIMES}/${date}/${duration}/${services}/employee/${employee}`);
  }

  static getUserByPhone(phone) {
    return axios.get(Config.API_URL.GET_USER_BY_PHONE + '/' + API._parsePhone(phone));
  }

  static validateConfirmationCode(bookingId, code) {
    return axios.get(Config.API_URL.VALIDATE_CODE + '/' + bookingId + '/' + code, {});
  }

  static saveBooking(booking = {}) {
    if (booking.gsm) {
      booking.gsm = API._parsePhone(booking.gsm);
    }

    return axios.post(Config.API_URL.SAVE_BOOKING, booking);
  }

  static updateBooking(id, booking = {}) {
    return axios.post(Config.API_URL.UPDATE_BOOKING + '/' + id, booking);
  }

  static saveUser(name, phone) {
    return axios.post(Config.API_URL.SAVE_USER, {
      nom: name,
      gsm: API._parsePhone(phone),
    });
  }

  static _parsePhone(phone) {
      // Format phone number for URL (remove spaces)
      return phone.replace(/ /g, '');
  }
}


// WEBPACK FOOTER //
// ./src/api/index.js